import useAppSelector from "@/core/helpers/useAppSelector";
import { estateSelector } from "@/domains/estate/slice";
import useSetResident from "@/domains/estate/hooks/useSetResident.ts";
import EstateSetResidentModal from "@/domains/estate/components/EstateSetResidentModal.tsx";

type Props = {
  setIsShow: (isShow: boolean) => void;
};

export default function EstateSetResidentContainer({ setIsShow }: Props) {
  const estate = useAppSelector(estateSelector);
  const { pending, setResident } = useSetResident({ setIsShow });

  return (
    <EstateSetResidentModal
      estateId={estate.id}
      estateType={estate.type}
      onClose={() => setIsShow(false)}
      address={estate.address}
      isLoading={pending}
      onConfirm={setResident}
    />
  );
}
